import React, { useEffect, useState, useRef } from 'react'
import Image from 'next/image'
import { Button } from 'reactstrap';
import styles from "../../styles/outletTemplate.module.css"
import dynamic from 'next/dynamic';
import VerificationPopup from '../modals/VerificationPopup';
import { preloadImages } from '@/utils/preloadImages';
import { getAbsoluteHeroImageStyle, getOutletHeroFloatStyle } from '../common/imageLayout/heroImageLayout';
const gsap = dynamic(() => import('gsap'), { ssr: false });
const ScrollTrigger = dynamic(() => import('gsap/dist/ScrollTrigger'), { ssr: false });

const HeroSection = ({ data }) => {
    const item = data && data[0] ? data[0] : {};
    const [isExpanded, setIsExpanded] = useState(false);
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setFormHeading] = useState("Book your free demo now!");
    const heroSectionRef = useRef(null);
    const textSectionRef = useRef(null);
    const centerImageRef = useRef(null);
    const imageSectionRef = useRef(null);
    useEffect(() => {
        let ctx;
        let cancelled = false;
        const initializeGSAP = async () => {
            if (typeof window !== 'undefined') {
                await preloadImages([
                    item.centerImage,
                    item.Image1?.src,
                    item.Image2?.src,
                    item.Image3?.src,
                    item.Image4?.src,
                    item.Image5?.src,
                    item.Image6?.src,
                    item.Image7?.src,
                    ...(Array.isArray(item.staticImages)
                        ? item.staticImages.map((img) => img?.src).filter(Boolean)
                        : []),
                ]);
                if (cancelled) return;

                const gsapModuleLoaded = await import('gsap');
                const ScrollTriggerModule = await import('gsap/dist/ScrollTrigger');
                if (cancelled) return;
                const gsapInstance = gsapModuleLoaded.default;
                gsapInstance.registerPlugin(ScrollTriggerModule.ScrollTrigger ?? ScrollTriggerModule.default?.ScrollTrigger ?? ScrollTriggerModule.default);

                ctx = gsapInstance.context(() => {
                    gsapInstance.set(`.${styles.UnderLine}`, { scaleX: 0, opacity: 0, transformOrigin: "center" });

                     
                    gsapInstance.to(`.${styles.UnderLine}`, {
                        scaleX: 1,
                        opacity: 1,
                        duration: 0.8,
                        ease: "power2.out",
                        delay: 0.3
                    });
                    gsapInstance.to(`.${styles.image1Container}`, {
                        scale: 1,
                        duration: 0.5,
                        ease: "back.out(1.7)",
                        delay: 0.1
                    });
                    gsapInstance.to(`.${styles.image2Container}`, {
                        scale: 1,
                        duration: 0.5,
                        ease: "back.out(1.7)",
                        delay: 0.3
                    });
                    gsapInstance.to(`.${styles.image3Container}`, {
                        scale: 1,
                        duration: 0.5,
                        ease: "back.out(1.7)",
                        delay: 0.6
                    });
                    gsapInstance.to(`.${styles.image4Container}`, {
                        scale: 1,
                        duration: 0.5,
                        ease: "back.out(1.7)",
                        delay: 0.9
                    });
                    gsapInstance.to(`.${styles.image5Container}`, {
                        scale: 1,
                        duration: 0.5,
                        ease: "back.out(1.7)",
                        delay: 1.2
                    });
                    gsapInstance.to(`.${styles.image6Container}`, {
                        scale: 1,
                        duration: 0.5,
                        ease: "back.out(1.7)",
                        delay: 1
                    });
                    gsapInstance.to(`.${styles.image7Container}`, {
                        scale: 1,
                        duration: 0.5,
                        ease: "back.out(1.7)",
                        delay: 1.5
                    });
                    
                    
                    if (textSectionRef.current) {
                        gsapInstance.to(textSectionRef.current, {
                            y: -150,
                            ease: "none",
                            scrollTrigger: {
                                trigger: heroSectionRef.current,
                                start: 'top top',
                                end: '+=400',
                                scrub: true,
                            }
                        });
                    }
                    if (imageSectionRef.current) {
                        gsapInstance.set(imageSectionRef.current, { y: 0 });
                        gsapInstance.to(imageSectionRef.current, {
                            y: -100,
                            ease: "none",
                            marginBottom: "-10rem", 
                            scrollTrigger: {
                                trigger: heroSectionRef.current,
                                start: 'top top',
                                end: '+=400',
                                scrub: true,
                            }
                        });
                    }
                    const imageContainers = [
                        `.${styles.image1Container}`,
                        `.${styles.image2Container}`,
                        `.${styles.image3Container}`,
                        `.${styles.image4Container}`,
                        `.${styles.image5Container}`,
                        `.${styles.image6Container}`
                    ];
                    imageContainers.forEach((selector, idx) => {
                        gsapInstance.to(selector, {
                            y: -100 - idx * 15, 
                            scrollTrigger: {
                                trigger: heroSectionRef.current,
                               start: 'top top',
                                end: '+=400',
                                scrub: true,
                            }
                        });
                    });
                }, heroSectionRef);
            }
        };
        initializeGSAP();
        return () => {
            cancelled = true;
            ctx && ctx.revert();
        };
    }, []);

    return (
        <div className={styles.heroSection} ref={heroSectionRef}>
            <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            <div className={styles.gradient_section} aria-hidden="true">
                <div className={styles.gradient_blue}></div>
                <div className={styles.gradient_orange}></div>
            </div>
            <div
                className={styles.textSection}
                ref={textSectionRef}
                style={{height: isExpanded ? '70rem' : '53rem',  transition: 'height 0.3s ease-in-out'}}>
                <div>
                <div
                className={styles.textContainer}
                style={{ transition: 'height 0.5s ease-in-out',}}
                >

                        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span suppressHydrationWarning={true} style={{ display: 'contents' }}>
                              <h1 style={{ fontSize: "3rem", fontFamily: "GilroyBold", lineHeight: "150%", color: "#F68E1E" }}>{item.title}</h1>
                            </span>
                            <div className={styles.UnderLine}><Image src="/assets/petStore/Isolation_Mode.svg" fill alt='line' /></div>
                        </div>
                    <div
                    className={styles.content}
                        style={{
                            transition: 'max-height 0.5s cubic-bezier(1, 0, 2, 1)',
                            maxHeight: isExpanded ? '65rem' : '10rem',
                        }}
                    >
                        <p
                            style={{
                                display: '-webkit-box',
                                WebkitLineClamp: isExpanded ? 'none' : 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                lineHeight: '1.7',
                                margin: '0 0 1rem 0',
                                transition: 'color 0.3s',
                                fontSize: '1.9rem',
                            }}
                        >
                            {item.text}
                        </p>
                        {item.text && item.text.length > 100 && (
                        
                            <button
                                onClick={() => setIsExpanded(!isExpanded)}
                                className={styles.readMoreButton}

                                style={{ width: 'fit-content', position: 'relative', height: '2rem', top: '-1rem' }}
                            >
                                {isExpanded ? 'Read Less' : 'Read More'}
                            </button>
                        )}
                    </div>
                    <Button
                        className={styles.demoButton}
                        style={{ width: 'fit-content' }}
                        onClick={() => {
                            setFormHeading('Get Free Demo');
                            setDemoModal(true);
                        }}
                    >
                        <span>Get Free Demo</span>
                    </Button>

                </div>
                </div>
                 

            </div>

            <div className={styles.imageSection} ref={imageSectionRef}> 
                <div style={{
                    color: 'white',
                    display: 'flex',
                    position: 'relative',
                    height: "15rem",
                    width: "70%",
                    maxWidth:"1250px",
                    margin:"0 auto",
                }}>
                    {item.centerImage && (
                        <div
                            className={styles.centerImageContainer}
                            ref={centerImageRef}
                            style={{
                                width: item?.width,
                                height: item?.height,
                                left: item?.left || '50%',
                                right: item?.right,
                                top: item?.top,
                                // bottom: item?.bottom ? item.bottom : '5rem',
                                transform: item?.left ? 'none' : 'translateX(-50%)',
                                willChange: 'transform',
                                position: 'absolute',  
                               
                            }}
                        >
                            <Image
                                src={item.centerImage}
                                alt="Center Image"
                                fill
                            />
                        </div>
                    )}
                    {Array.isArray(item.staticImages) &&
                        item.staticImages.map((img, idx) =>
                            img?.src ? (
                                <div
                                    key={img.src || `static-hero-${idx}`}
                                    className={styles.staticHeroImage}
                                    style={getAbsoluteHeroImageStyle(img)}
                                >
                                    <Image src={img.src} alt={img.alt || 'Image'} fill />
                                </div>
                            ) : null
                        )}
                    {item.Image1 && (
                        <div 
                            className={styles.image1Container}
                            style={getOutletHeroFloatStyle(item.Image1)}
                        >
                            <Image src={item.Image1.src} alt="Image"  fill />
                        </div>

                    )}
                    {item.Image2 && (
                        <div 
                            className={styles.image2Container}
                            style={getOutletHeroFloatStyle(item.Image2)}
                        >
                            <Image
                                src={item.Image2.src}
                                alt="Image"
                                fill
                            />
                        </div>
                    )}
                    {item.Image3 && (
                        <div 
                            className={styles.image3Container}
                            style={getOutletHeroFloatStyle(item.Image3)}
                        >
                            <Image
                                src={item.Image3.src}
                                alt="Image"
                                fill
                            />
                        </div>
                    )}
                    {item.Image4 && (
                        <div 
                            className={styles.image4Container}
                            style={getOutletHeroFloatStyle(item.Image4)}
                        >
                            <Image
                                src={item.Image4.src}
                                alt="Image"
                                fill
                            />
                        </div>
                    )}
                    {item.Image5 && (
                        <div 
                            className={styles.image5Container}
                            style={getOutletHeroFloatStyle(item.Image5)}
                        >
                            <Image
                                src={item.Image5.src}
                                alt="Image"
                                fill
                            />
                        </div>
                    )}
                    {item.Image6 && (
                        <div 
                            className={styles.image6Container}
                            style={getOutletHeroFloatStyle(item.Image6)}
                        >
                            <Image
                                src={item.Image6.src}
                                alt="Image"
                                fill
                            />
                        </div>
                    )}
                    {item.Image7 && (
                        <div 
                            className={styles.image7Container}
                            style={getOutletHeroFloatStyle(item.Image7)}
                        >
                            <Image
                                src={item.Image7.src}
                                alt="Image"
                                fill
                            />
                        </div>
                    )}
                </div>

                </div>
        </div>
    )
}


export default HeroSection
